<template>
  <div>
    <v-toolbar flat color="white">
      <h2 class="grey--text px-2 pt-3">Package Summary: {{locationnetwork.name}}</h2>
    </v-toolbar>
    <v-divider></v-divider>
    <v-toolbar flat color="white">
      <h3
        class="grey--text px-2 pt-3"
      >{{totalunits}} Units Passed || {{passiveinstalls}} Units Fibre Ready || {{activeinstalls}} Equipment Installs</h3>
    </v-toolbar>

    <v-toolbar flat class="white py-3">
      <v-flex xs12 sm12 md12 min-width="1000px">
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex xs3 sm3 md3 lg3 my-4>
              <v-card flat color="white">
                <h3>Total Sales:</h3>
                <h3 class="green--text">{{totalrevenue|currency}}</h3>
              </v-card>
            </v-flex>
            <v-flex xs3 sm3 md3 lg3 my-4>
              <v-card flat color="white">
                <h3>Total Cost of Sales:</h3>
                <h3 class="red--text">{{totalcost|currency}}</h3>
              </v-card>
            </v-flex>
            <v-flex xs3 sm3 md3 lg3 my-4>
              <v-card flat color="white">
                <h3>Gross Profit:</h3>
                <h3 class="green--text">{{totalgp|currency}}</h3>
              </v-card>
            </v-flex>
            <v-flex xs3 sm3 md3 lg3 my-4>
              <v-card flat color="white">
                <h3>Total Packages Sold:</h3>
                <h3>{{soldpackages}}</h3>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-toolbar>
    <v-card flat color="white">
      <v-container grid-list-xs>
        <v-layout wrap justify-center align-center>
          <v-flex xs12>
            <v-layout wrap justify-center>
              <v-card
                color="white"
                hover
                min-width="600px"
                class="mt-2 mx-3 align-center justify-center"
                v-if="fnopackages.length>0"
              >
                <h3 class="primary--text">Available FNO Packages:</h3>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex mx-3 xs12 v-for="fno in fnopackages" :key="fno.id">
                      <v-layout justify-center text-xs-left>
                        <v-flex xs4>
                          <h2 class="subheading grey--text font-weight-bold">{{fno.packageCode}}</h2>
                        </v-flex>
                        <v-flex xs4 text-xs-center>
                          <h3
                            class="grey--text font-weight-light"
                            v-if="locationnetwork.lineRentalIncluded&&fno.packagesFnoCat.packageCatType==='Residential'"
                          >{{(fno.packageBasePrice-locationnetwork.residentialLineRentalValue)|currency}}</h3>
                          <h3
                            class="grey--text font-weight-light"
                            v-else-if="locationnetwork.lineRentalIncluded&&fno.packagesFnoCat.packageCatType==='Business'"
                          >{{(fno.packageBasePrice-locationnetwork.businessLineRentalValue)|currency}}</h3>
                          <h3
                            class="grey--text font-weight-light"
                            v-else
                          >{{fno.packageBasePrice|currency}}</h3>
                        </v-flex>
                        <v-flex text-xs-center xs4 @click="addItem(fno)">
                          <v-icon color="primary">add_circle</v-icon>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-if="currentisppackages.length===0">
            <h3 class="grey--text mt-3">No ISP Packages Loaded.</h3>
          </v-flex>

          <v-flex xs12 sm6 md4 min-width="2000px"  v-if="loaded&&sortedPackages.length>0">
            <barchart
              :chartdata="ispPackagesChartData"
              :options="ispPackagesChartOptions"
            ></barchart>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4 v-if="loaded&&sortedPackages.length>0">
            <doughnutchart
              :chartdata="revenueGraph"
              :options="revenueGraphOptions"
            ></doughnutchart>
          </v-flex>
          <v-flex
            xs12
            sm6
            md6
            lg4
            v-if="currentisppackages.length>0&&(sortedPackages.length>0||unusedfnopackages.length>0)"
            justify-center
          >
            <v-card color="white" hover v-if="sortedPackages.length>0">
              <!-- <v-toolbar flat color="white">
                  <h3 justify-center class="subheading font-weight-bold mt-1 grey--text text-xs-center">
                      Package Popularity
                  </h3>
              </v-toolbar>-->
              <v-card-text>
                <v-flex>
                  <v-layout wrap>
                    <v-flex xs5>
                      <h3 class="primary--text">Package Name</h3>
                    </v-flex>
                    <v-flex xs2>
                      <v-divider vertical my-2></v-divider>
                    </v-flex>
                    <v-flex xs5>
                      <h3 class="primary--text">Percentage of Packages Sold</h3>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 v-for="sort in sortedPackages" :key="sort.id">
                      <v-layout justify-left text-xs-left>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">{{sort.name}}</h2>
                        </v-flex>
                        <v-flex xs4 text-xs-center>
                          <h3
                            class="grey--text font-weight-light"
                          >{{Math.round((sort.packageCount/soldpackages)*100)}}%</h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
            <v-card color="white" hover class="mt-2" v-if="unusedfnopackages.length>0">
              <h3 class="primary--text">Unused FNO Packages:</h3>
              <v-container grid-list-xs>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12 v-for="fno in unusedfnopackages" :key="fno.id">
                    <v-layout justify-left text-xs-left>
                      <v-flex xs8>
                        <h2 class="subheading grey--text font-weight-bold">{{fno.packageCode}}</h2>
                      </v-flex>
                      <v-flex xs4 text-xs-center>
                        <h3
                          class="grey--text font-weight-light"
                          v-if="locationnetwork.lineRentalIncluded&&fno.packagesFnoCat.packageCatType==='Residential'"
                        >{{(fno.packageBasePrice-locationnetwork.residentialLineRentalValue)|currency}}</h3>
                        <h3
                          class="grey--text font-weight-light"
                          v-else-if="locationnetwork.lineRentalIncluded&&fno.packagesFnoCat.packageCatType==='Business'"
                        >{{(fno.packageBasePrice-locationnetwork.businessLineRentalValue)|currency}}</h3>
                        <h3
                          class="grey--text font-weight-light"
                          v-else
                        >{{fno.packageBasePrice|currency}}</h3>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs12 v-if="currentisppackages.length>0">
            <h3 class="my-3 grey--text">Package Summary Table</h3>
            <v-data-table
              :items="currentisppackages"
              :headers="headers"
              class="elevation-1"
              disable-initial-sort
              item-key="id"
              align-center
              hide-actions
              :rows-per-page-items="[10, 25, 50, 100, 250]"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">
                  <v-layout justify-center>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" medium @click="editItem(props.item)">edit</v-icon>
                      </template>
                      <span>Edit Package</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" medium @click="deleteItem(props.item)">delete</v-icon>
                      </template>
                      <span>Delete Package</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" medium @click="previewPackage(props.item)">remove_red_eye</v-icon>
                      </template>
                      <span>Preview Package Card</span>
                    </v-tooltip>
                  </v-layout>
                </td>
                <td class="text-xs-center">
                  <v-icon
                    v-if="!props.item.isVerified"
                    color="red"
                    medium
                    @click="verifyItem(props.item)"
                  >cancel</v-icon>
                  <v-icon v-else color="tick" medium>check_circle_outline</v-icon>
                </td>
                <td class="text-xs-center">
                  <v-icon
                    v-if="props.item.isActive&&props.item.isVerified"
                    medium
                    color="tick"
                    @click="showHideItem(props.item)"
                  >check_circle_outline</v-icon>

                  <v-tooltip top v-else-if="props.item.isActive&&!props.item.isVerified">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class="ml-4"
                        v-on="on"
                        medium
                        color="orange"
                        @click="showHideItem(props.item)"
                      >error_outlined</v-icon>
                    </template>
                    <span>Verification Required</span>
                  </v-tooltip>
                  <v-icon v-else medium color="red" @click="showHideItem(props.item)">cancel</v-icon>
                </td>

                <td class="text-xs-center">
                  <v-chip
                    color="light-green white--text"
                    small
                    v-if="(!props.item.isDeleted&&props.item.endDate===null)||!props.item.isDeleted&&props.item.endDate!==null&&new Date(props.item.endDate)>new Date()"
                  >Active</v-chip>
                  <v-chip color="red white--text" small v-else>Inactive</v-chip>
                </td>
                <!-- <td class="text-xs-center">
          <v-chip color="light-green white--text" v-if="props.item.packagesFno.isActive">Active</v-chip>
          <v-chip color="red white--text" v-else>Inactive</v-chip>
          
                </td>-->
                <td class="text-xs-center">
                  <v-chip
                    color="light-green white--text"
                    v-if="props.item.ispLocationNetwork&&props.item.ispLocationNetwork.isActive && 
                    (props.item.packagesFno.endDate == null || (new Date(props.item.packagesFno.endDate)>new Date()))"
                  >Available</v-chip>
                  <v-chip color="red white--text" v-else>Not Available</v-chip>
                </td>
                <td class="text-xs-center">
                  {{formatDate(props.item.endDate)}}
                  <v-icon
                    v-if="props.item.endDate!==null&&new Date(props.item.endDate)<new Date()"
                    color="orange"
                  >warning</v-icon>
                </td>
                <td class="text-xs-center">{{props.item.name}}</td>
                <td class="text-xs-center">{{props.item.packageCount}}</td>
                <td
                  class="text-xs-center"
                >{{(props.item.packagesFno.packageBasePrice*(1+$VAT))|currency}}</td>
                <td class="text-xs-center">{{props.item.recurringPriceVatInc|currency}}</td>
                <td class="text-xs-center">{{props.item.recommendedRecurringPrice|currency}}</td>
                <td class="text-xs-center">{{props.item.estimatedRevenue|currency}}</td>
                <td class="text-xs-center">{{props.item.estimatedCost|currency}}</td>
                <td
                  class="text-xs-center green--text"
                  v-if="props.item.estimatedGP>0"
                >{{props.item.estimatedGP|currency}}</td>
                <td
                  class="text-xs-center red--text"
                  v-else-if="props.item.estimatedGP<0"
                >{{props.item.estimatedGP|currency}}</td>
                <td class="text-xs-center" v-else>{{props.item.estimatedGP|currency}}</td>
                 <td class="text-xs-center"
                    v-if="props.item.verifiedById">{{props.item.verifiedBy.name}} {{props.item.verifiedBy.surname}}</td>
                    <td class="text-xs-center"
                    v-else></td> 
                    <td class="text-xs-center"
                    v-if="props.item.lastModifiedById">{{props.item.lastModifiedBy.name}} {{props.item.lastModifiedBy.surname}}</td>
                     <td class="text-xs-center"
                    v-else></td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <!-- Add Package Modal -->
    <v-dialog persistent v-model="addPackageModal" max-width="750px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">Add Package: {{item.packageCode}}</h1>
        </v-toolbar>
        <v-card-text>
          <v-flex xs6>
            <v-switch
              v-model="item.attachPackageToTemplate"
              label="Attach Package to Template"
              persistent-hint
            ></v-switch>
          </v-flex>
          <v-flex
            xs6
            sm6
            md6
            v-if="item.attachPackageToTemplate&&availablePackageTemplates.length>0"
          >
            <v-autocomplete
              clearable
              flat
              v-on:keyup.enter="enterEvent"
              color="primary"
              label="*Select a Package Template"
              :items="availablePackageTemplates"
              item-text="name"
              item-value="id"
              return-object
              v-model="item.packagesIspTemplate"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            v-else-if="item.attachPackageToTemplate&&!speedErrorMessage&&availablePackageTemplates.length===0"
          >
            <span
              class="subheading"
            >You have no available Package Templates that match available speeds for this network.</span>
          </v-flex>
          <!-- <v-flex v-if="item.attachPackageToTemplate&&speedErrorMessage&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'">
                <span class="subheading red--text">Speed of {{item.packagesIspTemplate.name}} is not available on this network.</span>
          </v-flex>-->
          <v-flex
            xs6
            sm6
            md6
            v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
          ></v-flex>
        </v-card-text>
        <v-card-text>
          <h4
            class="dark-grey--text"
            v-if="(item.attachPackageToTemplate&&typeof item.packagesIsptemplate!=='undefined')||!item.attachPackageToTemplate"
          >Package Details</h4>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.speedProfile.name"
                  label="*Speed Profile"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.name"
                  label="*Package Name"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.description"
                  label="Description"
                  required
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.onceOffPrice"
                  label="Once Off Price Incl. VAT"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.recurringPrice"
                  label="Recurring Price Incl. VAT"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.term"
                  label="Term"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.isFup"
                  label="Fair Usage Policy"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              ></v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.isCapped"
                  label="Capped"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage&&item.packagesIspTemplate.isCapped"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.cappedAmountGb"
                  label="Term"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.isPromo"
                  label="Promotion"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage&&item.packagesIspTemplate.isPromo"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.promoDescription"
                  label="Promotion Description"
                  required
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIspTemplate!=='undefined'"
              >
                <v-checkbox
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.hasSpecificTerms"
                  label="This package has specific Terms and Conditions"
                  disabled
                  persistent-hint
                ></v-checkbox>
              </v-flex>
              <v-flex
                xs12
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIspTemplate!=='undefined'&&item.packagesIspTemplate.hasSpecificTerms"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.specificTerms"
                  label="Specific Terms and Conditions"
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex
                xs6
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <h4 class="dark-grey--text">
                  Once-off Gross Profit/Loss:
                  <h4
                    v-if="grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount) == 0"
                  >{{grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount) > 0"
                    class="green--text"
                  >{{grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount) < 0"
                    class="red--text"
                  >{{grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex
                xs6
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage&&typeof item!=='undefined'"
              >
                <h4 class="dark-grey--text">
                  Recurring Gross Profit/Loss:
                  <h4
                    v-if="locationnetwork.lineRentalIncluded&&grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice-locationnetwork.residentialLineRentalValue) == 0"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice) == 0"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="locationnetwork.lineRentalIncluded&&grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice-locationnetwork.residentialLineRentalValue) > 0"
                    class="green--text"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice) > 0"
                    class="green--text"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="locationnetwork.lineRentalIncluded&&grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice-locationnetwork.residentialLineRentalValue) < 0"
                    class="red--text"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice) < 0"
                    class="red--text"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packageBasePrice)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.name"
                  label="*Package Name"
                  hint="This is the title of your package card. Be sure to include your ISP name and speed profile. E.g. DEMOISP 20/10Mbps"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-autocomplete
                  id="addTermId"
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Contract Term"
                  :items="packageTerms"
                  v-model="item.term"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="!item.attachPackageToTemplate">
                <!-- <froala
                  :tag="'textarea'"
                  :config="textEditorConfig"
                  v-model="item.description"
                ></froala>-->
                <v-textarea
                  class="px-2"
                  v-model="item.description"
                  label="Package Description"
                  hint="Tell customers about this package and why they should select it. Are there any additional benefits? Or do you perhaps have FUP, throttling, shaping, etc.?"
                  persistent-hint
                ></v-textarea>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate"></v-flex> -->

              <v-flex xs12 sm12 md6 v-if="!item.attachPackageToTemplate">
                <v-switch
                  v-model="item.isPromotion"
                  label="This is a promotional package"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    id="addDateId"
                    :value="this.item.startDate"
                    slot="activator"
                    required
                    label="*Package Start Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="item.startDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate&&item.isPromotion">
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    v-show="item.isPromotion"
                    :value="this.item.endDate"
                    slot="activator"
                    label="Promotion End Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="item.endDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm12 md12 v-show="item.isPromotion&&!item.attachPackageToTemplate">
                <v-textarea
                  v-model="item.promotionDescription"
                  label="Promotion Description"
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-switch
                  v-model="item.isCapped"
                  label="Capped"
                  hint="Is this a Capped Package?"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm12 md6 v-if="!item.attachPackageToTemplate">
                <v-switch v-model="item.isShaped" label="This package is shaped" persistent-hint></v-switch>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-switch
                  v-model="item.isFup"
                  label="FUP"
                  hint="Do you have a Fair Usage Policy for this package?"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6 v-show="item.isCapped&&!item.attachPackageToTemplate">
                <v-text-field
                  v-model="item.cappedAmountGb"
                  label="CappedAmount"
                  hint="Capped amount in Gb"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-checkbox
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.hasSpecificTerms"
                  label="This package has specific Terms and Conditions"
                  persistent-hint
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 v-if="!item.attachPackageToTemplate&&item.hasSpecificTerms">
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.specificTerms"
                  label="Specific Terms and Conditions"
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-container grid-list-xs v-if="!item.attachPackageToTemplate">
                <v-layout wrap>
                  <v-flex xs12>
                    <h3 class="grey--text" v-if="!item.attachPackageToTemplate">Package Pricing</h3>
                  </v-flex>
                  <v-flex xs12 sm12 md12 px-3>
                  <!-- TODO: FIX -->
                  <!--
                    !-- <div v-if="((item.packagesFno.setupFee != null) && (item.packagesFno.setupFee != 0))"> --
                    <div v-if="item.setupFee">
                      <h4>Data Activation Fee Cost (incl. VAT): {{ item.setupFee | currency }}</h4>
                    </div>
                    <div v-else>
                      <h4>Data Activation Fee Cost (incl. VAT): {{ locationnetwork.activationFeeAmount*(1+$VAT) | currency }}</h4>
                    </div>
                  -->
                    <h4>Data Activation Fee Cost (incl. VAT): {{ locationnetwork.activationFeeAmount*(1+$VAT)|currency }}</h4> <!-- -->
                    <v-text-field
                      v-model="item.onceOffPriceVatInc"
                      label="*Total once off Costs to the end Client(incl. VAT)"
                      required
                      persistent-hint
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 px-3>
                    <h4
                      v-if="locationnetwork.lineRentalIncluded===true"
                    >Monthly Recurring VAS Fee Cost (incl. VAT): {{(item.packageBasePrice-locationnetwork.residentialLineRentalValue)*(1+$VAT)|currency}}</h4>
                    <h4
                      v-else
                    >Monthly Recurring VAS Fee Cost (incl. VAT): {{item.packageBasePrice*(1+$VAT)|currency}}</h4>
                    <v-text-field
                      v-model="item.recurringPriceVatInc"
                      label="*Total Monthly Price to end Client (incl. VAT)"
                      required
                      persistent-hint
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <h4 v-show="item.onceOffPriceVatInc" class="dark-grey--text">
                      Once-off Gross Profit/Loss:
                      <h4
                        v-if="grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount) == 0"
                      >{{grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount)| currency}}</h4>

                      <h4
                        v-if="grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount) > 0"
                        class="green--text"
                      >{{grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount)| currency}}</h4>

                      <h4
                        v-if="grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount) < 0"
                        class="red--text"
                      >{{grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount)| currency}}</h4>
                    </h4>
                  </v-flex>

                  <v-flex xs6 sm6 md6>
                    <h4 v-show="item.recurringPriceVatInc" class="dark-grey--text">
                      Recurring Gross Profit/Loss:
                      <h4
                        v-if="locationnetwork.lineRentalIncluded&&grossProfit(item.recurringPriceVatInc,item.packageBasePrice-locationnetwork.residentialLineRentalValue) == 0"
                      >{{grossProfit(item.recurringPriceVatInc,item.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                      <h4
                        v-else-if="grossProfit(item.recurringPriceVatInc,item.packageBasePrice) == 0"
                      >{{grossProfit(item.recurringPriceVatInc,item.packageBasePrice)| currency}}</h4>

                      <h4
                        v-else-if="locationnetwork.lineRentalIncluded&&grossProfit(item.recurringPriceVatInc,item.packageBasePrice-locationnetwork.residentialLineRentalValue) > 0"
                        class="green--text"
                      >{{grossProfit(item.recurringPriceVatInc,item.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                      <h4
                        v-else-if="grossProfit(item.recurringPriceVatInc,item.packageBasePrice) > 0"
                        class="green--text"
                      >{{grossProfit(item.recurringPriceVatInc,item.packageBasePrice)| currency}}</h4>

                      <h4
                        v-else-if="locationnetwork.lineRentalIncluded&&grossProfit(item.recurringPriceVatInc,item.packageBasePrice-locationnetwork.residentialLineRentalValue) < 0"
                        class="red--text"
                      >{{grossProfit(item.recurringPriceVatInc,item.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                      <h4
                        v-else-if="grossProfit(item.recurringPriceVatInc,item.packageBasePrice) < 0"
                        class="red--text"
                      >{{grossProfit(item.recurringPriceVatInc,item.packageBasePrice)| currency}}</h4>
                    </h4>
                  </v-flex>

                  <!-- <v-flex xs12 sm6 md6 v-show="item.isFup">
                <v-text-field
                  v-model="item.fupUrl"
                  label="Fair Usage Policy URL"
                  persistent-hint
                ></v-text-field>
                  </v-flex>-->
                </v-layout>
              </v-container>

              <v-flex 12 xs12 sm12 md>
                <v-card-actions>
                  <v-layout justify-center>
                    <v-btn color="primary" round @click="addPackageModal=false; item={}">Cancel</v-btn>
                    <v-btn
                      color="primary"
                      round
                      v-if="!item.attachPackageToTemplate&&item.name!==''&&typeof item.name !== 'undefined'&&item.term!==''&&
                      typeof item.recurringPriceVatInc !== 'undefined'&&item.recurringPriceVatInc!==''&&typeof item.onceOffPriceVatInc !== 'undefined'&&item.onceOffPriceVatInc!==''"
                      @click="saveNewPackage()"
                    >Create Package</v-btn>
                    <v-btn
                      color="primary"
                      round
                      v-else-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&availablePackageTemplates.length>0&&typeof item.packagesIspTemplate!=='undefined'&&!speedErrorMessage"
                      @click="createPackageFromTemplate()"
                    >Create Package</v-btn>
                    <v-btn v-else round disabled>Create Package</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Edit Package Modal -->
    <v-dialog persistent v-if="editDialog" v-model="editDialog" max-width="750px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">Edit Package: {{item.packagesFno.packageCode}}</h1>
        </v-toolbar>
        <v-card-text>
          <v-flex xs6>
            <v-switch
              v-model="item.attachPackageToTemplate"
              label="Attach Package to Template"
              persistent-hint
            ></v-switch>
          </v-flex>
          <v-flex
            xs6
            sm6
            md6
            v-if="item.attachPackageToTemplate&&availablePackageTemplates.length>0"
          >
            <v-autocomplete
              clearable
              flat
              v-on:keyup.enter="enterEvent"
              color="primary"
              label="*Select a Package Template"
              :items="availablePackageTemplates"
              item-text="name"
              item-value="id"
              return-object
              v-model="item.packagesIspTemplate"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            v-else-if="item.attachPackageToTemplate&&!speedErrorMessage&&availablePackageTemplates.length===0"
          >
            <span
              class="subheading"
            >You have no available Package Templates that match available speeds for this network.</span>
          </v-flex>
          <!-- <v-flex v-if="item.attachPackageToTemplate&&speedErrorMessage&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'">
                <span class="subheading red--text">Speed of {{item.packagesIspTemplate.name}} is not available on this network.</span>
          </v-flex>-->
          <v-flex
            xs6
            sm6
            md6
            v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
          ></v-flex>
        </v-card-text>
        <v-card-text>
          <h4
            class="dark-grey--text"
            v-if="(item.attachPackageToTemplate&&typeof item.packagesIsptemplate!=='undefined')||!item.attachPackageToTemplate"
          >Package Details</h4>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.speedProfile.name"
                  label="*Speed Profile"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.name"
                  label="*Package Name"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.description"
                  label="Description"
                  required
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.onceOffPrice"
                  label="Once Off Price Incl. VAT"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.recurringPrice"
                  label="Recurring Price Incl. VAT"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.term"
                  label="Term"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.isFup"
                  label="Fair Usage Policy"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              ></v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.isCapped"
                  label="Capped"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage&&item.packagesIspTemplate.isCapped"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.cappedAmountGb"
                  label="Term"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.isPromo"
                  label="Promotion"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage&&item.packagesIspTemplate.isPromo"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.promoDescription"
                  label="Promotion Description"
                  required
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIspTemplate!=='undefined'"
              >
                <v-checkbox
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.hasSpecificTerms"
                  label="This package has specific Terms and Conditions"
                  disabled
                  persistent-hint
                ></v-checkbox>
              </v-flex>
              <v-flex
                xs12
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIspTemplate!=='undefined'&&item.packagesIspTemplate.hasSpecificTerms"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.packagesIspTemplate.specificTerms"
                  label="Specific Terms and Conditions"
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex
                xs6
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage"
              >
                <h4 class="dark-grey--text">
                  Once-off Gross Profit/Loss:
                  <h4
                    v-if="grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount) == 0"
                  >{{grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount) > 0"
                    class="green--text"
                  >{{grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount) < 0"
                    class="red--text"
                  >{{grossProfit(item.packagesIspTemplate.onceOffPrice,locationnetwork.activationFeeAmount)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex
                xs6
                sm6
                md6
                v-if="item.attachPackageToTemplate&&item.packagesIspTemplate!==null&&typeof item.packagesIsptemplate!=='undefined'&&!speedErrorMessage&&typeof item!=='undefined'"
              >
                <h4 class="dark-grey--text">
                  Recurring Gross Profit/Loss:
                  <h4
                    v-if="locationnetwork.lineRentalIncluded&&grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue) == 0"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice) == 0"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="locationnetwork.lineRentalIncluded&&grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue) > 0"
                    class="green--text"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice) > 0"
                    class="green--text"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="locationnetwork.lineRentalIncluded&&grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue) < 0"
                    class="red--text"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice) < 0"
                    class="red--text"
                  >{{grossProfit(item.packagesIspTemplate.recurringPrice,item.packagesFno.packageBasePrice)| currency}}</h4>
                </h4>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.name"
                  label="*Package Name"
                  hint="This is the title of your package card. Be sure to include your ISP name and speed profile. E.g. DEMOISP 20/10Mbps"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-autocomplete
                  id="addTermId"
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Contract Term"
                  :items="packageTerms"
                  v-model="item.term"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="!item.attachPackageToTemplate">
                <!-- <froala
                  :tag="'textarea'"
                  :config="textEditorConfig"
                  v-model="item.description"
                ></froala>-->
                <v-textarea
                  class="px-2"
                  v-model="item.description"
                  label="Package Description"
                  hint="Tell customers about this package and why they should select it. Are there any additional benefits? Or do you perhaps have FUP, throttling, shaping, etc.?"
                  persistent-hint
                ></v-textarea>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate"></v-flex> -->

              <v-flex xs12 sm12 md6 v-if="!item.attachPackageToTemplate">
                <v-switch
                  v-model="item.isPromotion"
                  label="This is a promotional package"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    id="addDateId"
                    :value="this.item.startDate"
                    slot="activator"
                    required
                    label="*Package Start Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="item.startDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate&&item.isPromotion">
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    v-show="item.isPromotion"
                    :value="this.item.endDate"
                    slot="activator"
                    label="Promotion End Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="item.endDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm12 md12 v-show="item.isPromotion&&!item.attachPackageToTemplate">
                <v-textarea
                  v-model="item.promotionDescription"
                  label="Promotion Description"
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-switch
                  v-model="item.isCapped"
                  label="Capped"
                  hint="Is this a Capped Package?"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm12 md6 v-if="!item.attachPackageToTemplate">
                <v-switch v-model="item.isShaped" label="This package is shaped" persistent-hint></v-switch>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-switch
                  v-model="item.isFup"
                  label="FUP"
                  hint="Do you have a Fair Usage Policy for this package?"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6 v-show="item.isCapped&&!item.attachPackageToTemplate">
                <v-text-field
                  v-model="item.cappedAmountGb"
                  label="CappedAmount"
                  hint="Capped amount in Gb"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!item.attachPackageToTemplate">
                <v-checkbox
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.hasSpecificTerms"
                  label="This package has specific Terms and Conditions"
                  persistent-hint
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 v-if="!item.attachPackageToTemplate&&item.hasSpecificTerms">
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="item.specificTerms"
                  label="Specific Terms and Conditions"
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-container grid-list-xs>
                <v-layout wrap>
                  <v-flex xs12>
                    <h3 class="grey--text">Package Pricing</h3>
                  </v-flex>
                  <v-flex xs12 sm12 md12 px-3>
                    <!-- <div v-if="((item.packagesFno.setupFee != null) && (item.packagesFno.setupFee != 0))"> -->
                    <div v-if="item.packagesFno.setupFee">
                      <h4>Data Activation Fee Cost (incl. VAT): {{ item.packagesFno.setupFee | currency }}</h4>
                    </div>
                    <div v-else>
                      <h4>Data Activation Fee Cost (incl. VAT): {{ locationnetwork.activationFeeAmount*(1+$VAT) | currency }}</h4>
                    </div>
                    <!-- <h4>Data Activation Fee Cost (incl. VAT): {{ locationnetwork.activationFeeAmount*(1+$VAT)|currency }}</h4> -->
                    <v-text-field
                      v-model="item.onceOffPriceVatInc"
                      label="*Total once off Costs to the end Client(incl. VAT)"
                      required
                      persistent-hint
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 px-3>
                    <h4
                      v-if="locationnetwork.lineRentalIncluded===true"
                    >Monthly Recurring VAS Fee Cost (incl. VAT): {{(item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue)*(1+$VAT)|currency}}</h4>
                    <h4
                      v-else
                    >Monthly Recurring VAS Fee Cost (incl. VAT): {{item.packagesFno.packageBasePrice*(1+$VAT)|currency}}</h4>
                    <v-text-field
                      v-model="item.recurringPriceVatInc"
                      label="*Total Monthly Price to end Client (incl. VAT)"
                      required
                      persistent-hint
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <h4 class="dark-grey--text">
                      Once-off Gross Profit/Loss:
                      <h4
                        v-if="grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount) == 0"
                      >{{grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount)| currency}}</h4>

                      <h4
                        v-else-if="grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount) > 0"
                        class="green--text"
                      >{{grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount)| currency}}</h4>

                      <h4
                        v-else-if="grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount) < 0"
                        class="red--text"
                      >{{grossProfit(item.onceOffPriceVatInc,locationnetwork.activationFeeAmount)| currency}}</h4>
                    </h4>
                  </v-flex>

                  <v-flex xs6 sm6 md6>
                    <h4 v-show="item.recurringPriceVatInc" class="dark-grey--text">
                      Recurring Gross Profit/Loss:
                      <h4
                        v-if="locationnetwork.lineRentalIncluded&&grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue) == 0"
                      >{{grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                      <h4
                        v-else-if="grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice) == 0"
                      >{{grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice)| currency}}</h4>

                      <h4
                        v-else-if="locationnetwork.lineRentalIncluded&&grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue) > 0"
                        class="green--text"
                      >{{grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                      <h4
                        v-else-if="grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice) > 0"
                        class="green--text"
                      >{{grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice)| currency}}</h4>

                      <h4
                        v-else-if="locationnetwork.lineRentalIncluded&&grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue) < 0"
                        class="red--text"
                      >{{grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice-locationnetwork.residentialLineRentalValue)| currency}}</h4>
                      <h4
                        v-else-if="grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice) < 0"
                        class="red--text"
                      >{{grossProfit(item.recurringPriceVatInc,item.packagesFno.packageBasePrice)| currency}}</h4>
                    </h4>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-flex 12 xs12 sm12 md>
                <v-card-actions>
                  <v-layout justify-center>
                    <v-btn color="primary" round @click="editDialog=false, item={}">Cancel</v-btn>

                    <v-btn
                      color="primary"
                      round
                      v-if="!item.attachPackageToTemplate&&item.name!==''&&typeof item.name !== 'undefined'&&item.term!==''&&
                      typeof item.recurringPriceVatInc !== 'undefined'&&item.recurringPriceVatInc!==''&&typeof item.onceOffPriceVatInc !== 'undefined'&&item.onceOffPriceVatInc!==''"
                      @click="savePackage()"
                    >Save</v-btn>
                    <v-btn v-else round disabled>Save</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Package Card Preview -->
    <v-dialog persistent v-model="previewPackageModal" max-width="300px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Preview</h1>
        <v-spacer></v-spacer>
        <v-btn class="mx-0 px-0 white--text" small flat text @click="previewPackageModal=false">X</v-btn>
      </v-toolbar>
      <v-card flat color="white">
        <div v-if="previewPackageModal">
          <packagesispscards :cardsPerPage="1" :packagesIsps="packagePreviewCard"></packagesispscards>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import BarChart from "./BarChart.vue";
import PieChart from "./PieChart.vue";
import LineChart from "./LineChart.vue";
import DoughnutChart from "./DoughnutChart.vue";
import PackagesIspsCards from "@/components/PackagesIspsCards.vue";
import dateformat from "dateformat";
export default {
  components: {
    barchart: BarChart,
    piechart: PieChart,
    linechart: LineChart,
    doughnutchart: DoughnutChart,
    packagesispscards: PackagesIspsCards
  },
  props: [
    "locationnetwork",
    "fnopackages",
    "currentisppackages",
    "packagetemplates",
    "totalrevenue",
    "totalcost",
    "totalgp",
    "soldpackages",
    "unusedfnopackages",
    "totalunits",
    "activeinstalls",
    "passiveinstalls",
    "isplocationnetwork"
  ],
  data() {
    return {
      ispPackagesChartData: {},
      ispPackagesChartOptions: {},
      revenueGraph: {},
      revenueGraphOptions: {},
      loaded: false,
      sortedPackages: [],
      initialSortedPackages: [],
      packagePreviewCard: [],
      addPackageModal: false,
      previewPackageModal: false,
      editDialog: false,
      availablePackageTemplates: [],
      speedErrorMessage: false,
      // item: {},
      packageTerms: ["month-to-month", "6 month", "12 month", "24 month"],
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Verified Status",
          align: "center",
          value: "isVerified"
        },
        {
          text: "Visible on Application",
          align: "center",
          value: "isActive"
        },
        {
          text: "Status",
          align: "center",
          value: "isDeleted"
        },
        // {
        //   text: "FNO Package Status",
        //   align: "center",
        //   value: "packagesFno.isActive"
        // },
        {
          text: "FNO Package Availability",
          align: "center",
          value: "ispLocationNetwork.isActive"
        },
        {
          text: "Package End Date",
          align: "center",
          value: "endDate"
        },
        {
          text: "Package Name",
          align: "center",
          value: "name"
        },
        {
          text: "Active Connections",
          align: "center",
          value: "packageCount"
        },
        {
          text: "Cost Price (Incl. VAT)",
          align: "center",
          value: "packagesFno.packageBasePrice"
        },
        {
          text: "Selling Price (Incl. VAT)",
          align: "center",
          value: "recurringPriceVatInc"
        },
        {
          text: "Recommended Selling Price",
          align: "center",
          value: "packagesFno.recommendedSellingPrice"
        },
        {
          text: "Estimated Revenue",
          align: "center",
          value: "estimatedRevenue"
        },
        {
          text: "Estimated Cost",
          align: "center",
          value: "estimatedCost"
        },
        {
          text: "Estimated Gross Profit",
          align: "center",
          value: "estimatedGP"
        },
          {
          text: "Verified By",
          align: "center",
          value: "verifiedBy.name"
        },
        {
          text: "Last Modified By",
          align: "center",
          value: "lastModifiedBy.name"
        }
      ],
      item: {
        name: "",
        description: "",
        locationNetwork: "",
        locationNetworkId: "",
        onceOffPriceVatInc: "",
        recurringPriceVatInc: "",
        layer3Contention: "",
        isPromotion: "",
        term: "",
        fupUrl: "",
        isShaped: false,
        isCapped: "",
        cappedAmountGb: 0,
        isFup: false,
        startDate: null,
        endDate: null,
        packagesFnoId: "",
        packagesFno: "",
        packageCode: "",
        promotionDescription: "",
        customerId: "",
        customer: "",
        isVerified: null,
        createdById: null,
        lastModifiedById: null,
        verifiedById: null,
        attachPackageToTemplate: false,
        packagesIspTemplate: null,
        isActive: true,
        isDeleted: false
      }
    };
  },
  watch: {
    "item.packagesIspTemplate": {
      immediate: true,
      handler(value) {
        try {
          this.item.packagesIsptemplate = value;
        } catch {}
      }
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      try {
        this.loaded = false;
        //   Package Graph
        this.sortedPackages = [];
        let packageNames = [];
        let packageCounts = [];
        this.initialSortedPackages = this.currentisppackages;
        this.initialSortedPackages = this.initialSortedPackages.sort((a, b) =>
          a.packageCount < b.packageCount
            ? 1
            : b.packageCount < a.packageCount
            ? -1
            : 0
        );

        for (let i = 0; i < this.initialSortedPackages.length; i++) {
          if (this.initialSortedPackages[i].packageCount > 0) {
            await packageNames.push(this.initialSortedPackages[i].name);
            await packageCounts.push(
              this.initialSortedPackages[i].packageCount
            );
            await this.sortedPackages.push(this.initialSortedPackages[i]);
          }
        }
        (this.ispPackagesChartData = {
          labels: packageNames,
          datasets: [
            {
              label: "Packages Sold",
              data: packageCounts,
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(54, 162, 235, 0.2)",
                "rgba(255, 206, 86, 0.2)",
                "rgba(75, 192, 192, 0.2)",
                "rgba(153, 102, 255, 0.2)",
                "rgba(255, 159, 64, 0.2)"
              ],
              borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)"
              ],
              borderWidth: 1
            }
          ]
        }),
          (this.ispPackagesChartOptions = {
            title: {
              display: true,
              text: "Packages Sold"
            },
            tooltip: {
              enabled: true
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            }
          });
        let revenueGraphData = [];
        revenueGraphData.push(this.totalrevenue);
        revenueGraphData.push(this.totalcost);

        // Revenue vs Cost Graph
        this.revenueGraph = {
          labels: ["Sales", "Cost of Sales"],
          datasets: [
            {
              label: "Revenue vs Cost ",
              data: revenueGraphData,
              backgroundColor: [
                "rgba(38,231,147, 0.2)",
                "rgba(255, 99, 132, 0.2)"
              ],
              borderColor: ["rgba(38,231,147, 1)", "rgba(255, 99, 132, 1)"],
              borderWidth: 1
            }
          ]
        };
        this.revenueGraphOptions = {
          title: {
            display: true,
            text: "Financial Overview"
          }
        };
        this.loaded = true;
      } catch (e) {
        console.error(e);
      }
    },
    async addItem(item) {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.availablePackageTemplates = [];
        this.item = await Object.assign({}, item);
        let speedProfileId = item.speedProfileId;
        this.availablePackageTemplates = await this.packagetemplates.filter(
          function(el) {
            return el.speedProfileId === speedProfileId;
          }
        );
        if (this.item.endDate !== null) {
          this.item.endDate = new Date(this.item.endDate)
            .toISOString()
            .substr(0, 10);
        }
        if (this.item.startDate !== null) {
          this.item.startDate = new Date(this.item.startDate)
            .toISOString()
            .substr(0, 10);
        }
        console.log(this.item)
        this.addPackageModal = true;
      }
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    createPackageFromTemplate() {
      let ispLocationNetworkId = this.isplocationnetwork.find(
        x => x.packagesFnoId === this.item.id
      ).id;
      Api()
        .post("/customer/packagesIsps", {
          name: this.item.packagesIspTemplate.name,
          description: this.item.packagesIspTemplate.description,
          onceOffPriceVatInc: this.item.packagesIspTemplate.onceOffPrice,
          recurringPriceVatInc: this.item.packagesIspTemplate.recurringPrice,
          isPromotion: this.item.packagesIspTemplate.isPromo,
          promotionDescription: this.item.packagesIspTemplate.promoDescription,
          term: this.item.packagesIspTemplate.term,
          isCapped: this.item.packagesIspTemplate.isCapped,
          isShaped: this.item.packagesIspTemplate.isShaped,
          cappedAmountGb: this.item.packagesIspTemplate.cappedAmountGb,
          isFup: this.item.packagesIspTemplate.isFup,
          fupUrl: this.item.packagesIspTemplate.fupUrl,
          startDate: new Date(),
          endDate: null,
          packagesFnoId: this.item.id,
          ispLocationNetworkId: parseInt(ispLocationNetworkId),
          locationNetworkId: this.$route.params.locationNetworkId,
          isVerified: false,
          isRegistered: true,
          createdById: this.$store.state.user.id,
          lastModifiedById: this.$store.state.user.id,
          verifiedById: null,
          packagesIspTemplateId: this.item.packagesIspTemplate.id,
          customerOrganisationId: this.$store.state.currentOrg.org.id,
          hasSpecificTerms: this.item.packagesIspTemplate.hasSpecificTerms,
          specificTerms: this.item.packagesIspTemplate.specificTerms,
          isActive: true
        })
        .then(response => {
          this.$emit("refresh");
        });
    },
    saveNewPackage() {
      let ispLocationNetworkId = this.isplocationnetwork.find(
        x => x.packagesFnoId === this.item.id
      );
      Api()
        .post("/customer/packagesIsps", {
          name: this.item.name,
          description: this.item.description,
          promoDescription: this.item.promoDescription,
          onceOffPriceVatInc: this.item.onceOffPriceVatInc,
          recurringPriceVatInc: this.item.recurringPriceVatInc,
          isPromotion: this.item.isPromotion,
          term: this.item.term,
          isCapped: this.item.isCapped,
          cappedAmountGb: this.item.cappedAmountGb,
          isShaped: this.item.isShaped,
          isFup: this.item.isFup,
          fupUrl: this.item.fupUrl,
          startDate: this.item.startDate,
          endDate: this.item.endDate,
          packagesFnoId: this.item.id,
          locationNetworkId: this.$route.params.locationNetworkId,
          ispLocationNetworkId: ispLocationNetworkId.id,
          supplierOrganisationId:
            ispLocationNetworkId.locationNetwork.organisationId,
          isRegistered: true,
          isVerified: false,
          createdById: this.$store.state.user.id,
          lastModifiedById: this.$store.state.user.id,
          hasSpecificTerms: this.item.hasSpecificTerms,
          specificTerms: this.item.specificTerms
        })
        .then(response => {
          this.$emit("refresh");
        });
    },
    savePackage() {
      let ispLocationNetworkId = this.isplocationnetwork.find(
        x => x.packagesFnoId === this.item.packagesFno.id
      );
      if (this.item.attachPackageToTemplate) {
        Api()
          .put("/customer/packagesIsps/" + this.item.id, {
            name: this.item.packagesIspTemplate.name,
            description: this.item.packagesIspTemplate.description,
            promoDescription: this.item.packagesIspTemplate.promoDescription,
            onceOffPriceVatInc: this.item.packagesIspTemplate.onceOffPrice,
            recurringPriceVatInc: this.item.packagesIspTemplate.recurringPrice,
            isPromotion: this.item.packagesIspTemplate.isPromo,
            promotionDescription: this.item.packagesIspTemplate
              .promoDescription,
            term: this.item.packagesIspTemplate.term,
            isCapped: this.item.packagesIspTemplate.isCapped,
            isShaped: this.item.packagesIspTemplate.isShaped,
            cappedAmountGb: this.item.packagesIspTemplate.cappedAmountGb,
            isFup: this.item.packagesIspTemplate.isFup,
            startDate: this.item.startDate,
            endDate: this.item.endDate,
            packagesFnoId: this.item.packagesFno.id,
            locationNetworkId: this.$route.params.locationNetworkId,
            ispLocationNetworkId: ispLocationNetworkId,
            isVerified: this.item.isVerified,
            createdById: this.item.createdById,
            lastModifiedById: this.$store.state.user.id,
            verifiedById: this.item.verifiedById,
            packagesIspTemplateId: this.item.packagesIspTemplate.id,
            isActive: this.item.isActive,
            hasSpecificTerms: this.item.packagesIspTemplate.hasSpecificTerms,
            specificTerms: this.item.packagesIspTemplate.specificTerms
          })
          .then(response => {
            this.$emit("refresh");
          });
      } else {
        Api()
          .put("/customer/packagesIsps/" + this.item.id, {
            name: this.item.name,
            description: this.item.description,
            promoDescription: this.item.promoDescription,
            onceOffPriceVatInc: this.item.onceOffPriceVatInc,
            recurringPriceVatInc: this.item.recurringPriceVatInc,
            isPromotion: this.item.isPromotion,
            promotionDescription: this.item.promotionDescription,
            term: this.item.term,
            isCapped: this.item.isCapped,
            isShaped: this.item.isShaped,
            cappedAmountGb: this.item.cappedAmountGb,
            isFup: this.item.isFup,
            fupUrl: this.item.fupUrl,
            startDate: this.item.startDate,
            endDate: this.item.endDate,
            packagesFnoId: this.item.packagesFnoId,
            locationNetworkId: this.$route.params.locationNetworkId,
            isVerified: this.item.isVerified,
            createdById: this.item.createdById,
            lastModifiedById: this.$store.state.user.id,
            verifiedById: this.item.verifiedById,
            packagesIspTemplateId: null,
            isActive: this.item.isActive,
            hasSpecificTerms: this.item.hasSpecificTerms,
            specificTerms: this.item.specificTerms
          })
          .then(response => {
            this.$emit("refresh");
          });
      }
    },
    async showHideItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you would like to change the visibility of this package?"
        ) &&
          (await Api()
            .put("/customer/packagesIsps/" + item.id, {
              isActive: !item.isActive,
              isDeleted: false,
              lastModifiedById: this.$store.state.user.id
            })
            .then(async response => {
              let index = await this.currentisppackages.indexOf(item);
              this.currentisppackages[index].isActive = !item.isActive;
              this.currentisppackages[index].isDeleted = false;
            }));
      }
    },
    async verifyItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let isVerified = false;
        if (item.isVerified === null || item.isVerified === false) {
          isVerified = true;
        } else {
          isVerified = false;
        }
        confirm("Are you sure you would like to verify this package?") &&
          (await Api()
            .put("customer/packagesIsps/" + item.id, {
              isVerified: isVerified,
              verifiedById: this.$store.state.user.id
            })
            .then(async response => {
              let index = await this.currentisppackages.indexOf(item);
              this.currentisppackages[index].isVerified = isVerified;
            }));
      }
    },
    grossProfit(IspPrice, FnoPrice) {
      return parseFloat(IspPrice) - parseFloat(FnoPrice) * (1 + $VAT);
    },
    deleteItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm("Are you sure you want to delete this item?") &&
          Api()
            .put("/customer/packagesIsps/" + item.id, {
              isActive: false,
              isDeleted: true
            })
            .then(response => {
              this.$emit("refresh");
            });
      }
    },
    editItem(item) {
      if(item) {
        console.log(item);
      } else {
        console.log("No 1")
      }
      if(item.packagesFno) {
        console.log(item.packagesFno.setupFee)
      } else {
        console.log("No 2")
      }
      if(this.locationnetwork) {
        console.log(this.locationnetwork.activationFeeAmount)
      } else {
        console.log("No 3")
      }
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.availablePackageTemplates = [];
        this.item = Object.assign({}, item);
        let speedProfileId = item.packagesFno.speedProfileId;
        this.availablePackageTemplates = this.packagetemplates.filter(function(
          el
        ) {
          return el.speedProfileId === speedProfileId;
        });
        this.editDialog = true;
        //  this.getPackageDetails(this.item.packagesFnoId);
        //  this.fetchSelectedNetwork(this.item.locationNetworkId);
        //  this.getLocationPackages(this.item.locationNetworkId)
        if (this.item.packagesIspTemplateId !== null) {
          this.item.attachPackageToTemplate = true;
        }

        if (this.item.endDate !== null) {
          this.item.endDate = new Date(this.item.endDate)
            .toISOString()
            .substr(0, 10);
        }
        if (this.item.startDate !== null) {
          this.item.startDate = new Date(this.item.startDate)
            .toISOString()
            .substr(0, 10);
        }
        this.editDialog = true;
      }
    },
    async previewPackage(item) {
      this.packagePreviewCard = [];
      // console.log(item)
      if (item.customerOrganisationId === item.supplierOrganisationId) {
        item.customerOrganisation = this.$store.state.currentOrg.org;
      }
      await this.packagePreviewCard.push(item);
      this.previewPackageModal = true;
    }
  }
};
</script>